export const INCREMENT_LOADING_PROGRESS = 'INCREMENT_LOADING_PROGRESS'
export const RESET_LOADING_PROGRESS = 'RESET_LOADING_PROGRESS'

export const FETCH_OPTIONS = 'FETCH_OPTIONS'
export const OPTIONS_LOADED = 'OPTIONS_LOADED'
export const IMAGES_LOADED = 'IMAGES_LOADED'

export const STORE_FETCHED_MENUS = 'STORE_FETCHED_MENUS'
export const STORE_FETCHED_KEYWORDS = 'STORE_FETCHED_KEYWORDS'
export const STORE_FETCHED_LOCATIONS = 'STORE_FETCHED_LOCATIONS'

export const SET_FONT_SIIZE = 'SET_FONT_SIIZE'
export const SET_GUIDE_VISIBILITY = 'SET_GUIDE_VISIBILITY'
export const SET_FOOTER_TEXT_COLOR = 'SET_FOOTER_TEXT_COLOR'
export const SET_AUDIO_STATUS = 'SET_AUDIO_STATUS'
export const SET_BACK_BUTTON_STATUS = 'SET_BACK_BUTTON_STATUS'

export const SET_GUIDE_OBJECT = 'SET_GUIDE_OBJECT'

export const STORE_FETCHED_PAGES = 'STORE_FETCHED_PAGES'
export const PAGES_LOADED = 'PAGES_LOADED'

export const STORE_FETCHED_SPOT_LIST = 'STORE_FETCHED_SPOT_LIST'
export const STORE_FETCHED_TOUR_LIST = 'STORE_FETCHED_TOUR_LIST'
export const STORE_KEYWORD_SPOT_LIST = 'STORE_KEYWORD_SPOT_LIST'
export const STORE_LOCATION_SPOT_LIST = 'STORE_LOCATION_SPOT_LIST'
export const LIST_LOADED = 'LIST_LOADED'